import { render, staticRenderFns } from "./PPMFilters2.vue?vue&type=template&id=d5a9ed34&"
import script from "./PPMFilters2.vue?vue&type=script&lang=ts&"
export * from "./PPMFilters2.vue?vue&type=script&lang=ts&"
import style0 from "./PPMFilters2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PPMFilters2.vue"
export default component.exports